import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Dashboard from '../features/dashboard/components/Route';
import DocumentTypesRoute from '../features/documentTypes/components/list/Route';
import AllowedStatesRoute from '../features/documentTypes/components/edit/allowedStates/list/Route';
import AllowedStateRoute from '../features/documentTypes/components/edit/allowedStates/edit/Route';
import DocumentTypePropertiesListRoute from '../features/documentTypes/components/edit/properties/list/components/Route';
import DocumentTypePropertiesEditRoute from '../features/documentTypes/components/edit/properties/edit/components/Route';
import StateTransitionListRoute from '../features/documentTypes/components/edit/stateTransitions/list/Route';
import StateTransitionEditRoute from '../features/documentTypes/components/edit/stateTransitions/edit/Route';
import AuthorizationsRoute from '../features/security/components/authorization/Route';
import RefineAuthorizationRoute from '../features/security/components/RefineAuthorization/edit/Route';
import NotFound from '../components/common/NotFound';
import IncomeSourceListRoute from '../features/incomeSources/components/list/Route';
import ASTList from '../features/automaticStateTransition/components/list/Route';
import ASTEditRoute from '../features/automaticStateTransition/components/edit/Route';
import IncomeSourceRoute from '../features/incomeSources/components/edit/Route';
import FinancialIndicatorsRoute from '../features/financialIndicators/components/list/Route';
import FinancialIndicatorRoute from '../features/financialIndicators/components/edit/Route';
import ApprovalTypesListRoute from '../features/approvalTypes/components/list/Route';
import ClauseRoute from '../features/documentClause/components/list/Route';
import ClauseItemRoute from '../features/documentClause/components/edit/Route';
import ApprovalTypeEditRoute from '../features/approvalTypes/components/edit/Route';
import ApprovalTypeLevelEditRoute from '../features/approvalTypes/components/edit/approvalTypeLevel/Route';
import CompetenceOrderListRoute from '../features/competenceOrder/components/list/Route';
import CompetenceOrderEditRoute from '../features/competenceOrder/components/edit/Route';
import DictionariesRoute from '../features/dictionaries/list/components/Route';
import DictionaryRoute from '../features/dictionaries/edit/components/Route';
import SettingsRoute from '../features/settings/components/Route';
import EngineScoringGridListRoute from '../features/engineScoringGrid/components/list/Route';
import EngineScoringRoute from '../features/engineScoringGrid/components/edit/Route';
import TestEngineScoringRoute from '../features/engineScoringGrid/components/edit/TestEngineScoringRoute';
import VerificationTestFormulaRoute from '../features/verificationType/components/edit/components/VerificationTestFormulaRoute';
import ScoringCategoriesRoute from '../features/scoringCategory/components/list/Route';
import ScoringCategoryRoute from '../features/scoringCategory/components/edit/Route';
import EngineAttributesRoute from '../features/engineAttributes/components/list/Route';
import EngineAttributeRoute from '../features/engineAttributes/components/edit/Route';
import DocumentTemplateListRoute from '../features/documentTemplates/list/components/Route';
import DocumentTemplateEditRoute from '../features/documentTemplates/edit/components/Route';
import ChecklistListRoute from '../features/checklist/components/list/components/Route';
import ChecklistEditRoute from '../features/checklist/components/edit/components/Route';
import CommissionCalculationMethodsRoute from '../features/commissionCalculationMethods/list/Route';
import RequiredDocumentListRoute from '../features/requiredDocuments/components/list/components/Route';
import RequiredDocumentEditRoute from '../features/requiredDocuments/components/edit/components/Route';
import CancelOffersRoute from '../features/cancelOffers/components/Route';
import DealerBrandingRoute from '../features/branding/Route';
import AssetHierarchyPage from '../features/assetHierarchy/AssetHierarchyPage';
import ReportsRoute from '../features/reports/components/list/Route';
import ReportVerificationRoute from '../features/reportsVerification/components/list/Route';
import ReportRoute from '../features/reports/components/edit/Route';
import GenericEvaluationRoute from '../features/genericEvaluation/Route';
import QuestionnaireListRoute from '../features/questionnaires/components/list/Route';
import QuestionnaireEditRoute from '../features/questionnaires/components/edit/Route';
import DocumentSyncStateRoute from '../features/documentSyncState/components/Route';
import VerificationTypeListRoute from '../features/verificationType/components/list/components/Route';
import VerificationTypeEditRoute from '../features/verificationType/components/edit/components/Route';
import PartnerConsentsRoute from '../features/partnerConsents/components/Route';
import ParameterListContainerRoute from '../features/initializationParams/components/Route';
import TextResourceContainerRoute from '../features/textResource/components/Route';
import ContextRetriever from '../components/menu/ContextRetriever';
import GenericEntityFlowRoute from '../features/genericEntityFlow/list/components/Route';
import GenericEntityFlowEditRoute from '../features/genericEntityFlow/edit/Route';
import DocumentSignStateTransitionsRoute from '../features/documentSignStateTransitions/components/Route';
import AutomaticUserAllocationRoute from '../features/automaticUserAllocation/components/Route';
import PropertyListRoute from '../features/properties/components/list/components/Route';
import Forbidden from 'components/common/Forbidden';
import PropertyEditRoute from '../features/properties/components/edit/components/Route';
import GenericFilterParamListRoute from '../features/genericFilters/list/components/Route';
import GenericFilterParamEditRoute from '../features/genericFilters/edit/Route';
import GenericFilterTemplatesListRoute from '../features/genericFilterTemplates/list/components/Route';
import GenericFilterTemplateRoute from '../features/genericFilterTemplates/edit/components/Route';
import LeasingInterestsRoute from '../features/leasingInterests/list/components/Route';
import LeasingServiceTypeRoute from '../features/leasingServiceType/list/components/Route';
import LeasingServiceTypeLinkingsRoute from '../features/leasingServiceType/linkings/components/Route';
import LeasingServiceTypeEditRoute from '../features/leasingServiceType/edit/components/Route';
import ResidualValueGridRoute from '../features/residualValueGrid/list/components/Route';
import ResidualValueGridEditRoute from '../features/residualValueGrid/edit/components/Route';
import LeasingIncomeSchemaRoute from '../features/leasingIncomeSchema/list/components/Route';
import LeasingIncomeSchemaEditRoute from '../features/leasingIncomeSchema/edit/components/Route';
import LeasingExpenseTypeRoute from '../features/leasingExpenseType/list/components/Route';
import LeasingExpenseTypeEditRoute from '../features/leasingExpenseType/edit/components/Route';
import InsuranceConventionRoute from '../features/insuranceConventions/list/components/Route';
import NumericPrecisionRoute from '../features/numericPrecision/Route';
import AccountStatementRoute from '../features/accountStatement/list/Route';
import AccountStatementEditRoute from '../features/accountStatement/edit/components/Route';
import InsuranceConventionEditRoute from '../features/insuranceConventions/edit/components/Route';
import ItemsRoute from '../features/items/list/components/Route';
import ItemEditRoute from '../features/items/edit/components/Route';
import CitiesRoute from '../features/city/components/Route';
import ExchangeRatesRoute from '../features/exchangeRates/list/components/Route';
import TaxRateListRoute from '../features/taxRates/components/Route';
import FinancialProductsRoute from '../features/financialProducts/list/components/Route';
import LeasingCommissionListRoute from '../features/leasingCommission/list/components/Route';
import LeasingInterestTypeDetailsRoute from '../features/floatingInterest/list/components/Route';
import FinancialProductEditRoute from '../features/financialProducts/edit/components/Route';
import FinancialProductRuleEditRoute from '../features/financialProducts/edit/components/details/Rules/edit/Route';
import FinancialProductWarrantyEditRoute from '../features/financialProducts/edit/components/details/Warranties/edit/Route';
import { UsersPage, UsersEditPage } from '../features/users';
import UserGroupListRoute from '../features/userGroups/list/components/Route';
import UserGroupEditRoute from '../features/userGroups/edit/components/Route';
import ScheduleTypeCellParamTemplatesRoute from '../features/schedules/scheduleTypeCellParamTemplates/list/components/Route';
import ScheduleTypeCellParamTemplateEditRoute from '../features/schedules/scheduleTypeCellParamTemplates/edit/components/Route';
import PartnerTypeRoute from '../features/partnerTypes/components/list/components/Route';
import ContentTypesListRoute from '../features/contentTypes/list/components/Route';
import ContentTypesEditRoute from '../features/contentTypes/edit/components/Route';
import MetadataRoute from '../features/metadata/list/components/Route';
import NonWorkingDaysRoute from '../features/nonWorkingDays/list/components/Route';
import { entityContext, entityContextRoutes } from '../constants/entityContexts';
import { useForbiddenAccessClamp } from 'hooks';
import { useServiceRoute } from 'hooks/useDashboardMenu';
import { Insurance, Origination } from 'constants/contexts';
import CustomRoute from 'components/routing/CustomRoute';

const AppRoutes = () => {
  useForbiddenAccessClamp();

  return (
    <Switch>
      <Route exact path='/dashboard'>
        <CustomRoute component={Dashboard} />
      </Route>
      <Redirect exact from='/' to='/dashboard' />
      <Route exact {...useServiceRoute('/documentTypes')}>
        <CustomRoute component={DocumentTypesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/allowedStates')}>
        <CustomRoute component={AllowedStatesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/security')}>
        <CustomRoute component={AuthorizationsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/security/authorization/:authorizationId([+\\-]?\\d+)')}>
        <CustomRoute component={RefineAuthorizationRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/allowedStates/:allowedStateId([+\\-]?\\d+)')}>
        <CustomRoute component={AllowedStateRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/allowedStates/new')}>
        <CustomRoute component={AllowedStateRoute} />
      </Route>
      <Route exact {...useServiceRoute('/automaticStateTransitions')} component={ASTList} />
      <Route exact {...useServiceRoute('/automaticStateTransitions/:automaticStateTransitionId([+\\-]?\\d+)')}>
        <CustomRoute component={ASTEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/automaticStateTransitions/new')}>
        <CustomRoute component={ASTEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/documentTypeProperties')}>
        <CustomRoute component={DocumentTypePropertiesListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/documentTypeProperties/:propertyId([+\\-]?\\d+)')}>
        <CustomRoute component={DocumentTypePropertiesEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/documentTypeProperties/new')}>
        <CustomRoute component={DocumentTypePropertiesEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/stateTransitions')}>
        <CustomRoute component={StateTransitionListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/stateTransitions/:stateTransitionId([+\\-]?\\d+)')}>
        <CustomRoute component={StateTransitionEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTypes/:documentTypeId([+\\-]?\\d+)/stateTransitions/new')}>
        <CustomRoute component={StateTransitionEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/initializationParams')}>
        <CustomRoute component={ParameterListContainerRoute} />
      </Route>
      <Route exact {...useServiceRoute('/textResource')}>
        <CustomRoute component={TextResourceContainerRoute} />
      </Route>
      <Route exact {...useServiceRoute('/incomeSources')}>
        <CustomRoute component={IncomeSourceListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/incomeSources/:id([+\\-]?\\d+)')}>
        <CustomRoute component={IncomeSourceRoute} />
      </Route>
      <Route exact {...useServiceRoute('/incomeSources/new')}>
        <CustomRoute component={IncomeSourceRoute} />
      </Route>
      <Route exact {...useServiceRoute('/approvalTypes')}>
        <CustomRoute component={ApprovalTypesListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/approvalTypes/new')}>
        <CustomRoute component={ApprovalTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/approvalTypes/:approvalTypeId([+\\-]?\\d+)/:siteId(\\d+)')}>
        <CustomRoute component={ApprovalTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/dictionaries')}>
        <CustomRoute component={DictionariesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/dictionaries/:id([+\\-]?\\d+)')}>
        <CustomRoute component={DictionaryRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentClause')}>
        <CustomRoute component={ClauseRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentClause/:clauseId([+\\-]?\\d+)')}>
        <CustomRoute component={ClauseItemRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentClause/new')}>
        <CustomRoute component={ClauseItemRoute} />
      </Route>
      <Route exact {...useServiceRoute('/branding')}>
        <CustomRoute component={DealerBrandingRoute} />
      </Route>
      <Route exact {...useServiceRoute('/assetHierarchy')}>
        <CustomRoute component={AssetHierarchyPage} />
      </Route>
      <Route exact {...useServiceRoute('/cancelOffers')}>
        <CustomRoute component={CancelOffersRoute} />
      </Route>
      <Route exact {...useServiceRoute('/genericEvaluation')}>
        <CustomRoute component={GenericEvaluationRoute} />
      </Route>
      <Route
        exact
        {...useServiceRoute(
          '/approvalTypes/:approvalTypeId([+\\-]?\\d+)/:siteId(\\d+)/approvalTypeLevel/:approvalTypeLevelId([+\\-]?\\d+)/:siteId(\\d+)'
        )}
      >
        <CustomRoute component={ApprovalTypeLevelEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/approvalTypes/:approvalTypeId([+\\-]?\\d+)/:siteId(\\d+)/new')}>
        <CustomRoute component={ApprovalTypeLevelEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringEngine')}>
        <CustomRoute component={EngineScoringGridListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringEngine/new')}>
        <CustomRoute component={EngineScoringRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringEngine/:engineScoringId([+\\-]?\\d+)')}>
        <CustomRoute component={EngineScoringRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringEngine/:engineScoringId([+\\-]?\\d+)/test')}>
        <CustomRoute component={TestEngineScoringRoute} />
      </Route>
      <Route exact {...useServiceRoute('/verificationTypes/:verificationTypeId([+\\-]?\\d+)/test')}>
        <CustomRoute component={VerificationTestFormulaRoute} />
      </Route>
      <Route exact {...useServiceRoute('/competenceOrders')}>
        <CustomRoute component={CompetenceOrderListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialIndicators')}>
        <CustomRoute component={FinancialIndicatorsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialIndicators/:id([+\\-]?\\d+)')}>
        <CustomRoute component={FinancialIndicatorRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialIndicators/new')}>
        <CustomRoute component={FinancialIndicatorRoute} />
      </Route>
      <Route exact {...useServiceRoute('/competenceOrders/:competenceOrderId([+\\-]?\\d+)')}>
        <CustomRoute component={CompetenceOrderEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/competenceOrders/new')}>
        <CustomRoute component={CompetenceOrderEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/engineAttributes')}>
        <CustomRoute component={EngineAttributesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/engineAttributes/new')}>
        <CustomRoute component={EngineAttributeRoute} />
      </Route>
      <Route exact {...useServiceRoute('/engineAttributes/:id([+\\-]?\\d+)')}>
        <CustomRoute component={EngineAttributeRoute} />
      </Route>
      <Route exact path='/settings' component={SettingsRoute}>
        <CustomRoute component={SettingsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringCategories')} component={ScoringCategoriesRoute}>
        <CustomRoute component={ScoringCategoriesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringCategories/new')}>
        <CustomRoute component={ScoringCategoryRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scoringCategories/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ScoringCategoryRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialIndicators')}>
        <CustomRoute component={FinancialIndicatorRoute} />
      </Route>
      <Route exact {...useServiceRoute('/reports')}>
        <CustomRoute component={ReportsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/reports/new')}>
        <CustomRoute component={ReportRoute} />
      </Route>
      <Route exact {...useServiceRoute('/reports/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ReportRoute} />
      </Route>
      <Route exact {...useServiceRoute('/reportsVerification')}>
        <CustomRoute component={ReportVerificationRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTemplates')}>
        <CustomRoute component={DocumentTemplateListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTemplates/:documentTemplateId([+\\-]?\\d+)')}>
        <CustomRoute component={DocumentTemplateEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentTemplates/new')}>
        <CustomRoute component={() => <DocumentTemplateEditRoute bulkPrintingYN={false} />} />
      </Route>
      <Route exact {...useServiceRoute('/documentTemplates/newBulk')}>
        <CustomRoute component={() => <DocumentTemplateEditRoute bulkPrintingYN={true} />} />
      </Route>
      <Route exact {...useServiceRoute('/checklist')}>
        <CustomRoute component={ChecklistListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/checklist/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ChecklistEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/checklist/new')}>
        <CustomRoute component={ChecklistEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/commissionCalculationMethods')}>
        <CustomRoute component={CommissionCalculationMethodsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/requiredDocuments')}>
        <CustomRoute component={RequiredDocumentListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/requiredDocuments/:id([+\\-]?\\d+)')}>
        <CustomRoute component={RequiredDocumentEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/requiredDocuments/new')}>
        <CustomRoute component={RequiredDocumentEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/questionnaires')}>
        <CustomRoute component={QuestionnaireListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/questionnaires/:questionnaireId([+\\-]?\\d+)')}>
        <CustomRoute component={QuestionnaireEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/questionnaires/new')}>
        <CustomRoute component={QuestionnaireEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentSignStateTransitions')}>
        <CustomRoute component={DocumentSignStateTransitionsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/documentSyncState')}>
        <CustomRoute component={DocumentSyncStateRoute} />
      </Route>
      <Route exact {...useServiceRoute('/verificationTypes')}>
        <CustomRoute component={VerificationTypeListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/verificationTypes/:verificationTypeId([+\\-]?\\d+)')}>
        <CustomRoute component={VerificationTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/partnerConsents')}>
        <CustomRoute component={PartnerConsentsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/automaticUserAllocation')}>
        <CustomRoute component={AutomaticUserAllocationRoute} />
      </Route>
      <Route exact {...useServiceRoute('/properties')}>
        <CustomRoute component={PropertyListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/properties/new')}>
        <CustomRoute component={PropertyEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/properties/:id([+\\-]?\\d+)')}>
        <CustomRoute component={PropertyEditRoute} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.checkList]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.checkList} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.checkList]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.checkList} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.checkList]}/new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.checkList} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.financialProduct]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.financialProduct} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.financialProduct]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.financialProduct} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.financialProduct]}/:new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.financialProduct} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.genericMatrix]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.genericMatrix} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.genericMatrix]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.genericMatrix} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.genericMatrix]}/:new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.genericMatrix} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.genericMatrixTemplate]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.genericMatrixTemplate} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.genericMatrixTemplate]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.genericMatrixTemplate} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.genericMatrixTemplate]}/:new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.genericMatrixTemplate} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.incomeSchema]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.incomeSchema} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.incomeSchema]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.incomeSchema} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.incomeSchema]}/:new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.incomeSchema} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.residualValueGrid]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.residualValueGrid} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.residualValueGrid]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.residualValueGrid} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.residualValueGrid]}/:new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.residualValueGrid} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.subsidyMatrix]}`)}>
        <CustomRoute component={GenericEntityFlowRoute} entityContext={entityContext.subsidyMatrix} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.subsidyMatrix]}/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.subsidyMatrix} />
      </Route>
      <Route exact {...useServiceRoute(`/${entityContextRoutes[entityContext.subsidyMatrix]}/:new`)}>
        <CustomRoute component={GenericEntityFlowEditRoute} entityContext={entityContext.subsidyMatrix} />
      </Route>
      <Route exact {...useServiceRoute('/genericFilterTemplates')}>
        <CustomRoute component={GenericFilterTemplatesListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/genericFilterTemplates/new')}>
        <CustomRoute component={GenericFilterTemplateRoute} />
      </Route>
      <Route exact {...useServiceRoute('/genericFilterTemplates/:id([+\\-]?\\d+)')}>
        <CustomRoute component={GenericFilterTemplateRoute} />
      </Route>
      <Route exact {...useServiceRoute('/exchangeRates')}>
        <CustomRoute component={ExchangeRatesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/taxRates')}>
        <CustomRoute component={TaxRateListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/genericFilterParams')}>
        <CustomRoute component={GenericFilterParamListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/genericFilterParams/:id([+\\-]?\\d+)')}>
        <CustomRoute component={GenericFilterParamEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts')}>
        <CustomRoute component={FinancialProductsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts/:id([+\\-]?\\d+)')}>
        <CustomRoute component={FinancialProductEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts/new')}>
        <CustomRoute component={FinancialProductEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts/:id([+\\-]?\\d+)/rules/:ruleId([+\\-]?\\d+)')}>
        <CustomRoute component={FinancialProductRuleEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts/:id([+\\-]?\\d+)/rules/new')}>
        <CustomRoute component={FinancialProductRuleEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts/:id([+\\-]?\\d+)/warranties/:leasingFinancialProductXWarrantyId([+\\-]?\\d+)')}>
        <CustomRoute component={FinancialProductWarrantyEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/financialProducts/:id([+\\-]?\\d+)/warranties/new')}>
        <CustomRoute component={FinancialProductWarrantyEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/users')}>
        <CustomRoute component={UsersPage} />
      </Route>
      <Route exact {...useServiceRoute('/users/:id([+\\-]?\\d+)')}>
        <CustomRoute component={UsersEditPage} />
      </Route>
      <Route exact {...useServiceRoute('/users/new')}>
        <CustomRoute component={UsersEditPage} />
      </Route>
      <Route exact {...useServiceRoute('/userGroups')}>
        <CustomRoute component={UserGroupListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/userGroups/:id([+\\-]?\\d+)')}>
        <CustomRoute component={UserGroupEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/userGroups/new')}>
        <CustomRoute component={UserGroupEditRoute} />
      </Route>
      <Route exact path='/forbidden' component={Forbidden} />
      <Route exact path={`/:serviceRoute(:?${Origination.serviceRoute}|${Insurance.serviceRoute})`}>
        <CustomRoute component={ContextRetriever} />
      </Route>
      <Route exact {...useServiceRoute('/insuranceConventions')}>
        <CustomRoute component={InsuranceConventionRoute} />
      </Route>
      <Route exact {...useServiceRoute('/numericPrecision')}>
        <CustomRoute component={NumericPrecisionRoute} />
      </Route>
      <Route exact {...useServiceRoute('/accountStatement')}>
        <CustomRoute component={AccountStatementRoute} />
      </Route>
      <Route exact {...useServiceRoute(`/accountStatement/:id([+\\-]?\\d+)`)}>
        <CustomRoute component={AccountStatementEditRoute} />
      </Route>
      <Route exact {...useServiceRoute(`/accountStatement/new`)}>
        <CustomRoute component={AccountStatementEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/insuranceConventions/:id([+\\-]?\\d+)')}>
        <CustomRoute component={InsuranceConventionEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/insuranceConventions/new')}>
        <CustomRoute component={InsuranceConventionEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/items')}>
        <CustomRoute component={ItemsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/items/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ItemEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/items/new')}>
        <CustomRoute component={ItemEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/cities')}>
        <CustomRoute component={CitiesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingCommissions')}>
        <CustomRoute component={LeasingCommissionListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingInterestTypeDetails')}>
        <CustomRoute component={LeasingInterestTypeDetailsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingInterests')}>
        <CustomRoute component={LeasingInterestsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingServiceTypes')}>
        <CustomRoute component={LeasingServiceTypeRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingServiceTypeLinkings')}>
        <CustomRoute component={LeasingServiceTypeLinkingsRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingServiceTypes/new')}>
        <CustomRoute component={LeasingServiceTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingServiceTypes/:id([+\\-]?\\d+)')}>
        <CustomRoute component={LeasingServiceTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/residualValueGrids')}>
        <CustomRoute component={ResidualValueGridRoute} />
      </Route>
      <Route exact {...useServiceRoute('/residualValueGrids/new')}>
        <CustomRoute component={ResidualValueGridEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/residualValueGrids/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ResidualValueGridEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingIncomeSchemas')}>
        <CustomRoute component={LeasingIncomeSchemaRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingIncomeSchemas/new')}>
        <CustomRoute component={LeasingIncomeSchemaEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingIncomeSchemas/:id([+\\-]?\\d+)')}>
        <CustomRoute component={LeasingIncomeSchemaEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingExpenseTypes')}>
        <CustomRoute component={LeasingExpenseTypeRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingExpenseTypes/new')}>
        <CustomRoute component={LeasingExpenseTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/leasingExpenseTypes/:id([+\\-]?\\d+)')}>
        <CustomRoute component={LeasingExpenseTypeEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scheduleTypeCellParamTemplates')}>
        <CustomRoute component={ScheduleTypeCellParamTemplatesRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scheduleTypeCellParamTemplates/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ScheduleTypeCellParamTemplateEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/scheduleTypeCellParamTemplates/new')}>
        <CustomRoute component={ScheduleTypeCellParamTemplateEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/contentTypes')}>
        <CustomRoute component={ContentTypesListRoute} />
      </Route>
      <Route exact {...useServiceRoute('/contentTypes/:id([+\\-]?\\d+)')}>
        <CustomRoute component={ContentTypesEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/contentTypes/new')}>
        <CustomRoute component={ContentTypesEditRoute} />
      </Route>
      <Route exact {...useServiceRoute('/metadata')}>
        <CustomRoute component={MetadataRoute} />
      </Route>
      <Route exact {...useServiceRoute('/nonWorkingDays')}>
        <CustomRoute component={NonWorkingDaysRoute} />
      </Route>
      <Route exact {...useServiceRoute('/partnerTypes')}>
        <CustomRoute component={PartnerTypeRoute} />
      </Route>
      <Route render={() => <NotFound title='PageNotFound' />} />
    </Switch>
  );
};

export default AppRoutes;
